import { useAddFriend } from '@src/hooks/useFriends';
import { useState } from 'react';
import {
  Button,
  buttonVariants,
  Dialog,
  DialogClose,
  DialogContent,
  DialogTitle,
  DialogTrigger,
  Input,
  Spinner,
  Text,
  VStack,
} from 'ui_2';
import { BiCheck, BiPlus, BiX } from 'react-icons/bi';

const getValidationElement = (
  value: string,
  isLoadingValidity: boolean,
  isValidFriendUsername: boolean | undefined
) => {
  if (value.length < 3) return;

  if (isLoadingValidity) {
    return <Spinner className='text-gray-500' />;
  }

  if (isValidFriendUsername === true) {
    return (
      <div className='flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-green-400'>
        <BiCheck color='white' size={20} />
      </div>
    );
  }

  if (isValidFriendUsername === false) {
    return (
      <div className='flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-red-400'>
        <BiX color='white' size={20} />
      </div>
    );
  }

  return undefined;
};

export const AddFriend = () => {
  const [newFriendUsername, setNewFriendUsername] = useState('');

  const {
    addFriend,
    isLoading,
    error,
    isValidFriendUsername,
    isLoadingValidity,
  } = useAddFriend(newFriendUsername);

  return (
    <Dialog>
      <DialogTrigger
        className={buttonVariants({
          variant: 'gray',
          className: 'w-fit min-w-[120px] items-center gap-2',
          size: 'md',
        })}
      >
        <BiPlus />
        <Text font='sm'>Add Friends</Text>
      </DialogTrigger>
      <DialogContent
        className='max-w-[min(90%,400px)]'
        aria-describedby={undefined}
      >
        <DialogTitle>
          <Text font='bold-md'>Add a Friend</Text>
        </DialogTitle>
        <DialogClose />
        <VStack className='gap-2'>
          <Text className='text-sm text-gray-600'>
            Enter your friend's username. Both of you need to add each other to
            become friends.
          </Text>
          <Input
            placeholder={`Enter friend's username`}
            autoCapitalize='none'
            autoComplete='none'
            autoCorrect='none'
            value={newFriendUsername}
            onChange={(e) => setNewFriendUsername(e.target.value)}
            disabled={isLoading}
            error={error?.message}
            rightElement={getValidationElement(
              newFriendUsername,
              isLoadingValidity,
              isValidFriendUsername
            )}
          />
          <Button
            onClick={() => addFriend()}
            disabled={
              isLoading ||
              !newFriendUsername.trim() ||
              isLoadingValidity ||
              !isValidFriendUsername
            }
            size='md'
            className='w-full items-center gap-2'
          >
            Add Friend
            {isLoading && <Spinner />}
          </Button>
        </VStack>
      </DialogContent>
    </Dialog>
  );
};
